import React, { Dispatch, FC, SetStateAction, useEffect, useState } from 'react';
import { TextField, Tooltip } from '@mui/material';
// fetch
import { formatMoney } from '../../../../../helpers';
import { IBudgetOption, ISelectedBudgetOption } from '../../../../../models';

interface IBudgetOptionsField {
  option: IBudgetOption;
  selectedOptions: ISelectedBudgetOption[];
  setSelectedOptions: Dispatch<SetStateAction<ISelectedBudgetOption[]>>;
}

export const BudgetOptionsField: FC<IBudgetOptionsField> = ({
  option,
  selectedOptions,
  setSelectedOptions
}) => {
  const [displayBudgetValue, setDisplayBudgetValue] = useState<string | null>(
    !!selectedOptions
      ?.find(selectedOption => selectedOption.optionId === option.optionId)
      ?.price?.toString()
      ? formatMoney(
          selectedOptions
            ?.find(selectedOption => selectedOption.optionId === option.optionId)
            ?.price?.toString()
        )
      : null
  );
  useEffect(() => {
    setDisplayBudgetValue(
      !!selectedOptions
        ?.find(selectedOption => selectedOption.optionId === option.optionId)
        ?.price?.toString()
        ? formatMoney(
            selectedOptions
              ?.find(selectedOption => selectedOption.optionId === option.optionId)
              ?.price?.toString()
          )
        : null
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedOptions]);

  const handleUpdateSelectedOptions = value => {
    setSelectedOptions(prev => {
      const selectedOption = prev.find(
        selectedOption => selectedOption.optionId === option.optionId
      );
      if (!value) {
        return prev.filter(selectedOption => selectedOption.optionId !== option.optionId);
      } else {
        if (selectedOption) {
          const cleanedArray = prev.filter(
            selectedOption => selectedOption.optionId !== option.optionId
          );
          return [
            ...cleanedArray,
            {
              neighborhoodSeriesOptionBudgetId:
                selectedOption?.neighborhoodSeriesOptionBudgetId ?? 0,
              price: parseInt(value),
              optionId: option.optionId
            }
          ];
        } else {
          return [
            ...prev,
            {
              neighborhoodSeriesOptionBudgetId:
                selectedOption?.neighborhoodSeriesOptionBudgetId ?? 0,
              price: parseInt(value),
              optionId: option.optionId
            }
          ];
        }
      }
    });
  };

  return (
    <Tooltip title="If a price is entered, this option will be included" arrow>
      <TextField
        fullWidth
        variant="outlined"
        autoComplete="nope"
        label={`${option.optionSetName} - ${option.name}`}
        name={`${option.optionSetName} - ${option.name}`}
        size="small"
        value={displayBudgetValue}
        onBlur={e => {
          // Need to strip out all non numeric values from formatted value
          const value = e.target.value.replace('$', '').replace(',', '');

          if (!!value) {
            setDisplayBudgetValue(formatMoney(value));
          }
          handleUpdateSelectedOptions(value);
        }}
        onChange={e => {
          if (e.target.value === '') {
            setDisplayBudgetValue(null);
          }
          setDisplayBudgetValue(e.target.value);
        }}
      />
    </Tooltip>
  );
};
